import { mapState } from 'pinia';
import stores from 'store/modules';

export default {
    computed: {
        ...mapState(stores.Inboxes, ['inbox']),
    },

    methods: {
        echoConversationRead(e) {
            this.$store.dispatch('setUnreadCount', e);
            this.$store.dispatch('updateConversation', {
                conversation: e.conversation,
            });
        },

        echoConversationUnread(e) {
            this.$store.dispatch('setUnreadCount', e);
            this.$store.dispatch('updateConversation', {
                conversation: e.conversation,
                excludeProps: [
                    'last_message_at',
                    'draft_message',
                    'hasCurrentSocket',
                    'draftInitializedForm',
                    'debounceNotifyDrafting',
                ],
                updateProps: true,
            });
            // TODO: SWR-14336: Will be uncommit and updated with SWR-14336
            // this.$store.dispatch('setLogItem', {
            //     logLevel: 'info',
            //     message: 'EventConversationUnread',
            //     details: {
            //         conversationId: e.conversation.id,
            //         totalUnread: e.conversation.unread_count,
            //         conversationUnread: Boolean(e.conversation.unread_count),
            //         lastReadAt: e.conversation.last_read_at,
            //         lastMessageAt: e.conversation.last_message_at,
            //     },
            // });
        },
    },
};
